import React from 'react';

type LoadingProps = {
    nameOfClass?: string;
};

const Loading = ({ nameOfClass }: LoadingProps) => (
    <div className={`loading ${nameOfClass ? nameOfClass : ''}`}>
        <span className="loading__item"></span>
        <span className="loading__item"></span>
        <span className="loading__item"></span>
        <span className="loading__item"></span>
        <span className="loading__item"></span>
        <span className="loading__item"></span>
    </div>
);

/** Centered in the workspace (auth, lazy editor chunk, asset fetch). */
export const PageLoading = () => (
    <section className="main__content workspace workspace--loading">
        <Loading />
    </section>
);

export default Loading;
